// Generated by ReScript, PLEASE EDIT WITH CARE

import * as React from "react";

function LoadingViewComponent(Props) {
  var textOpt = Props.text;
  var text = textOpt !== undefined ? textOpt : "Loading";
  return React.createElement("div", {
              className: "u-margin-bottom-small u-margin-top-small u-text-centre loader-container"
            }, React.createElement("h3", {
                  className: "header__h3"
                }, text), React.createElement("div", {
                  className: "loader u-margin-0-auto"
                }));
}

var make = LoadingViewComponent;

export {
  make ,
  
}
/* react Not a pure module */
